import { Container } from 'pixi.js';
import type { Game } from './Game';
import type { Insets } from '@/platform/safeArea';

/**
 * Base class for every screen (menu, dungeon, results, ...).
 * A scene owns a single root container that is added to the stage on enter
 * and destroyed on exit.
 */
export abstract class Scene {
  readonly root = new Container();

  constructor(protected readonly game: Game) {}

  /** Logical (CSS px) viewport width. */
  protected get width(): number {
    return this.game.width;
  }
  protected get height(): number {
    return this.game.height;
  }

  /** Safe-area insets (CSS px) to keep UI clear of the notch / home indicator. */
  protected get insets(): Insets {
    return this.game.insets;
  }

  /** Called once after the root is attached to the stage. */
  abstract enter(): void;

  /** Fixed-timestep update. dt is in seconds. */
  update(_dt: number): void {}

  /** Viewport changed size. */
  resize(_w: number, _h: number): void {}

  /** Called before the root is destroyed. Override to release listeners. */
  exit(): void {}
}
